module.exports = __webpack_public_path__ + "img/code.3559d192.png";